export default function CalendarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-10"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3v2.25m10.5-2.25V5.25M3.75 9.75h16.5M4.5 6.75h15a1.5 1.5 0 011.5 1.5v10.5a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5zM8.25 14.25h.008v.008H8.25v-.008zM12 14.25h.008v.008H12v-.008zM15.75 14.25h.008v.008h-.008v-.008z"
      />
    </svg>
  );
}
